import { Suspense } from 'react';
import {
  Redirect,
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,

} from 'react-router-dom';

import { useAuth } from '../contexts/auth';
import { URI } from '../contracts/enums';
import BlockedContent from '../components/BlockedContent';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
}

const PremiumRoute: React.FC<RouteProps> = ({
  isPrivate = false,
  children,
  ...rest
}) => {
  const { user } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user ? (
          <Suspense fallback={''}>
            {user?.isPremium ?
            <>
              { children }
            </> : 
            <BlockedContent />
          }
          </Suspense>
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? URI.base : URI.dashboard,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default PremiumRoute;